// Auburn University's undergraduate majors (#2746). Read on 2026-10-01 from
// the official 2026-2027 Auburn University Bulletin, Undergraduate Majors
// (bulletin.auburn.edu/undergraduate/majors), which lists each program under
// its college with options, tracks and degree types. Each major appears once
// per college with its degree (BS, BA, BSBA, BArch, BFA, ...): options,
// tracks and pre-professional concentrations (for example Animal Sciences'
// two options, the Music BMU tracks, Biomedical Sciences' pre-pharmacy
// concentration) are folded into their major. Biosystems Engineering is
// listed under both Agriculture and Engineering, as the Bulletin lists it.
// Biomedical Sciences and Microbiology are named here from the Bulletin's
// A-Z list, where the college list shows only their concentrations.
const majors = {
    "slug": "auburn-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Auburn's 2026-2027 Bulletin, grouped by the college that offers it, with the degree it leads to. Options, tracks and pre-professional concentrations sit inside their major. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Agriculture",
            "source": {
                "label": "Auburn University Bulletin 2026-2027, Undergraduate Majors",
                "url": "https://bulletin.auburn.edu/undergraduate/majors/"
            },
            "majors": [
                {
                    "name": "Agricultural Business & Economics",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural Communications",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural Science",
                    "degree": "BS"
                },
                {
                    "name": "Animal Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Applied Biotechnology",
                    "degree": "BS"
                },
                {
                    "name": "Biological and Agricultural Technology Management",
                    "degree": "BS"
                },
                {
                    "name": "Biosystems Engineering",
                    "degree": "BBSE"
                },
                {
                    "name": "Crop and Soil Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Fisheries, Aquaculture, and Aquatic Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Horticulture",
                    "degree": "BS"
                },
                {
                    "name": "Poultry Science",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Architecture, Design, and Construction",
            "source": {
                "label": "Auburn University Bulletin 2026-2027, Undergraduate Majors",
                "url": "https://bulletin.auburn.edu/undergraduate/majors/"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "BArch"
                },
                {
                    "name": "Building Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Design",
                    "degree": "BS"
                },
                {
                    "name": "Graphic Design",
                    "degree": "BFA"
                },
                {
                    "name": "Industrial Design",
                    "degree": "BIND"
                },
                {
                    "name": "Architecture/Interior Architecture",
                    "degree": "BIARCH"
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "BLA"
                }
            ]
        },
        {
            "name": "Raymond J. Harbert College of Business",
            "source": {
                "label": "Auburn University Bulletin 2026-2027, Undergraduate Majors",
                "url": "https://bulletin.auburn.edu/undergraduate/majors/"
            },
            "majors": [
                {
                    "name": "Accountancy",
                    "degree": "BSBA"
                },
                {
                    "name": "Business Administration",
                    "degree": "BSBA"
                },
                {
                    "name": "Business Analytics",
                    "degree": "BSBA"
                },
                {
                    "name": "Finance",
                    "degree": "BSBA"
                },
                {
                    "name": "Information Systems Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BSBA"
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "BSBA"
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "Auburn University Bulletin 2026-2027, Undergraduate Majors",
                "url": "https://bulletin.auburn.edu/undergraduate/majors/"
            },
            "majors": [
                {
                    "name": "Agricultural Education, Leadership and Communications",
                    "degree": "BS"
                },
                {
                    "name": "Business and Marketing Education",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry Education",
                    "degree": "BS"
                },
                {
                    "name": "Collaborative Teacher Special Education: K-12",
                    "degree": "BS"
                },
                {
                    "name": "Early Childhood Education",
                    "degree": "BS"
                },
                {
                    "name": "Early Childhood/Elementary Special Education: P-6",
                    "degree": "BS"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BS"
                },
                {
                    "name": "English Language Arts Education/English",
                    "degree": "BS"
                },
                {
                    "name": "Exercise, Performance, & Health Optimization",
                    "degree": "BS"
                },
                {
                    "name": "Exercise Science",
                    "degree": "BS"
                },
                {
                    "name": "French Education",
                    "degree": "BS"
                },
                {
                    "name": "General Science Education",
                    "degree": "BS"
                },
                {
                    "name": "General Social Science Education",
                    "degree": "BS"
                },
                {
                    "name": "German Education",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics Education",
                    "degree": "BS"
                },
                {
                    "name": "Music Education: Instrumental and Vocal",
                    "degree": "BMED"
                },
                {
                    "name": "Physics Education",
                    "degree": "BS"
                },
                {
                    "name": "Rehabilitation and Disability Studies",
                    "degree": "BS"
                },
                {
                    "name": "Spanish Education",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Samuel Ginn College of Engineering",
            "source": {
                "label": "Auburn University Bulletin 2026-2027, Undergraduate Majors",
                "url": "https://bulletin.auburn.edu/undergraduate/majors/"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "BAE"
                },
                {
                    "name": "Biosystems Engineering",
                    "degree": "BBSE"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BCHE"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BCE"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BCPE"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science (online degree completer)",
                    "degree": "BCS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BEE"
                },
                {
                    "name": "Industrial and Systems Engineering",
                    "degree": "BISE"
                },
                {
                    "name": "Materials Engineering",
                    "degree": "BMTLE"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BME"
                },
                {
                    "name": "Software Engineering",
                    "degree": "BSWE"
                }
            ]
        },
        {
            "name": "College of Forestry, Wildlife and Environment",
            "source": {
                "label": "Auburn University Bulletin 2026-2027, Undergraduate Majors",
                "url": "https://bulletin.auburn.edu/undergraduate/majors/"
            },
            "majors": [
                {
                    "name": "Environmental Conservation and Management",
                    "degree": "BS"
                },
                {
                    "name": "Forestry",
                    "degree": "BS"
                },
                {
                    "name": "Geospatial Information Science",
                    "degree": "BS"
                },
                {
                    "name": "Parks and Recreation Management",
                    "degree": "BS"
                },
                {
                    "name": "Sustainable Packaging",
                    "degree": "BS"
                },
                {
                    "name": "Wildlife Ecology and Management",
                    "degree": "BS"
                },
                {
                    "name": "Wildlife Enterprise Management",
                    "degree": "BS"
                },
                {
                    "name": "Wildlife Sciences",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Human Sciences",
            "source": {
                "label": "Auburn University Bulletin 2026-2027, Undergraduate Majors",
                "url": "https://bulletin.auburn.edu/undergraduate/majors/"
            },
            "majors": [
                {
                    "name": "Apparel Merchandising, Design and Production Management",
                    "degree": "BS"
                },
                {
                    "name": "Global Studies in Human Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Hospitality Management",
                    "degree": "BS"
                },
                {
                    "name": "Human Development and Family Science",
                    "degree": "BS"
                },
                {
                    "name": "Interior Design",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition",
                    "degree": "BS"
                },
                {
                    "name": "Philanthropy and Non-Profit Studies",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Liberal Arts",
            "source": {
                "label": "Auburn University Bulletin 2026-2027, Undergraduate Majors",
                "url": "https://bulletin.auburn.edu/undergraduate/majors/"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "BS"
                },
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Art Studio/Fine Arts",
                    "degree": "BFA"
                },
                {
                    "name": "Aviation Management",
                    "degree": "BS"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Film and Media Studies",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "Health Services Administration",
                    "degree": "BS"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "International Studies",
                    "degree": "BA"
                },
                {
                    "name": "Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Law and Justice",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BMU"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Professional Flight",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Public Administration",
                    "degree": "BA"
                },
                {
                    "name": "Public Relations",
                    "degree": "BA"
                },
                {
                    "name": "Social Work",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Speech, Language, and Hearing Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Theatre/Fine Arts",
                    "degree": "BFA"
                }
            ]
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "Auburn University Bulletin 2026-2027, Undergraduate Majors",
                "url": "https://bulletin.auburn.edu/undergraduate/majors/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BS"
                },
                {
                    "name": "RN to BSN",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "James Harrison College of Pharmacy",
            "source": {
                "label": "Auburn University Bulletin 2026-2027, Undergraduate Majors",
                "url": "https://bulletin.auburn.edu/undergraduate/majors/"
            },
            "majors": [
                {
                    "name": "Drug and Biopharmaceutical Sciences",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Sciences and Mathematics",
            "source": {
                "label": "Auburn University Bulletin 2026-2027, Undergraduate Majors",
                "url": "https://bulletin.auburn.edu/undergraduate/majors/"
            },
            "majors": [
                {
                    "name": "Applied Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Genetics",
                    "degree": "BS"
                },
                {
                    "name": "Geography and Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "Geology",
                    "degree": "BS"
                },
                {
                    "name": "Laboratory Science",
                    "degree": "BS"
                },
                {
                    "name": "Marine Biology",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Medical Laboratory Science",
                    "degree": "BS"
                },
                {
                    "name": "Microbiology",
                    "degree": "BS"
                },
                {
                    "name": "Microbial, Cellular and Molecular Biology",
                    "degree": "BS"
                },
                {
                    "name": "Organismal Biology",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Veterinary Medicine",
            "source": {
                "label": "Auburn University Bulletin 2026-2027, Undergraduate Majors",
                "url": "https://bulletin.auburn.edu/undergraduate/majors/"
            },
            "majors": [
                {
                    "name": "Public and One Health",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "University College",
            "source": {
                "label": "Auburn University Bulletin 2026-2027, Undergraduate Majors",
                "url": "https://bulletin.auburn.edu/undergraduate/majors/"
            },
            "majors": [
                {
                    "name": "Interdisciplinary University Studies",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
